import { Injectable } from '@angular/core';
import { BaseService } from '../alcance/services/_base.service';
import { PlantaoDBService } from '../database/plantao-db.service';
import { Capacitor } from '@capacitor/core';

@Injectable({
  providedIn: 'root'
})
export class PlantaoService extends BaseService{
    override classname: string = 'PlantaoService';
    public override route: string = 'plantao';
    public override database = Capacitor.isNativePlatform() ? new PlantaoDBService() : new PlantaoDBService();

    public override novo() {
        return {
            atendimentos: [],
            atividades: [],
            liberacoes: [],
            servicos: [],
            formularios: [],
            ocorrencias: []
        }
    }
}
